import React, { Component } from "react";
import { ControlledEditor } from "@monaco-editor/react";

// Clear undo stack of Ace Editor prevent CMD+Z from working on page load
// causing initial content to disapear
// function resetUndoStack(editor) {
//     setTimeout(()=>{
//         editor.getSession().setUndoManager(new brace.UndoManager());
//     }, 50);
// }

export default class AceEditorDefaultValues extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataString: "",
    };
  }

  componentWillMount() {
    this.onDataChange = this.onDataChange.bind(this);
  }

  componentDidMount() {
    this.setState({
      dataString: this.props.defaultValue,
    });
  }

  onDataChange(newValue) {
    this.setState({
      dataString: newValue,
    });
    this.props.onChange(newValue);
  }

  render() {
    return (
      <ControlledEditor
        width="100%"
        height="100%"
        language={this.props.mode}
        theme="vs-dark"
        value={this.state.dataString}
        options={{
          tabSize: 2,
          minimap: {
            enabled: false,
          },
          automaticLayout: true,
        }}
        onChange={(e, v) => {
          this.onDataChange(v);
        }}
      />
    );
  }
}

AceEditorDefaultValues.propTypes = {};
